<template>
  <div class="reset-password-container">
    <div class="reset-password-box">

      <div class="reset-password-header">
        <button class="close" @click="goHomepage">&times;</button>
        <div class="header-logo"></div>
        <div class="header-title">Reset Password</div>
      </div>

      <el-alert v-if="resetSuccess" title="Reset password successful" type="success"
                description="Your password successfully reset." show-icon></el-alert>

        <template v-else>
          <div class="reset-password-auth-body">
            <el-alert v-if="error" title="Sorry, something went wrong" type="error" :description="error"
                      show-icon></el-alert>
            <el-form v-if="userData" ref="resetForm" :model="form" :rules="rules">
              <el-form-item label="Password" :inline-message="true" prop="password">
                <el-input type="password" v-model="form.password" size="medium" autocomplete="off" show-password />
              </el-form-item>
              <el-form-item label="Confirm new password" prop="checkPass">
                <el-input type="password" v-model="form.checkPass" size="medium" autocomplete="off"
                          show-password></el-input>
              </el-form-item>
              <template v-if="userData.mobile">
                <p>
                  We have sent a text message to your mobile number. Please enter the
                  6 digit code from that message below:
                </p>
                <el-form-item :inline-message="true" prop="token" class="request-token">
                  <el-input v-model="form.token" size="medium" />
                </el-form-item>
                <span class="text-muted">Your token expires in 2 minutes. If you do not have access to your mobile number then please call 02 8356 0300</span>
              </template>
              <div class="form-action">
                <el-button type="success" class="btn-submit" :disabled="loading" @click="submitForm('resetForm')">
                  Save
                </el-button>
              </div>
            </el-form>
          </div>
        </template>
      </div>

    </div>
</template>

<script>
import {mapState, mapActions} from 'vuex'
// import getParams from '../store/helper'

export default {
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input the password'));
      } else {
        if (this.form.checkPass !== '') {
          this.$refs.resetForm.validateField('checkPass');
        }
        callback();
      }
    };

    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input the password again'));
      } else if (value !== this.form.password) {
        callback(new Error('Two inputs don\'t match!'));
      } else {
        callback();
      }
    };

    return {
      // params: {},
      artifact: null,
      form: {
        password: '',
        checkPass: '',
        token: ''
      },
      rules: {
        password: [
          {validator: validatePass, trigger: 'blur'},
          {min: 7, message: 'Length should be greater or equal to 6', trigger: 'blur'}
        ],
        checkPass: [
          {validator: validatePass2, trigger: 'blur'}
        ],
        token: {required: true, message: 'Token required', trigger: 'blur'}
      }
    }
  },
  created() {
    // this.params = getParams();

    const params = new URLSearchParams(window.location.search)
    this.artifact = params.get('Artifact')

    if (!this.artifact) {
      this.error = 'It appears that your reset link is invalid. Please try again.'
      return
    }

    this.getUserReset({artifact: this.artifact});
  },
  computed: {
    ...mapState({
      userData: state => state.auth.reset,
      loading: state => state.auth.loading,
      error: state => state.auth.error,
      resetSuccess: state => state.auth.resetSuccess,
    })
  },
  methods: {
    ...mapActions('auth', ['getUserReset', 'resetPassword']),
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          return false;
        }

        await this.resetPassword({
          "artifact": this.artifact,
          "token_2fa": this.form.token,
          "password": this.form.password
        });
      });
    },
    phoneEnding() {
      return this.userData.mobile.substring(this.userData.mobile.length - 3);
    },
    goHomepage() {
      window.location.href = `http://${window.location.host}`
    }
  }
}
</script>

<style lang="scss" scoped>

  .reset-password-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(#ccc, .95);
    overflow: auto;
    z-index: 2;

    @media (max-height: 850px) {
      align-items: flex-start;
      padding: 1em 0;
    }
  }

  .reset-password-box {
    border: solid 1px #A5A5A5;
    border-radius: 3px;
    background-color: #fff;
    max-width: 500px;
    width: 90vw;
    margin: 2em 0 5em;

    @media (min-width: 600px) {
      width: 50vw;
    }

    @media (min-width: 800px) {
      width: 40vw;
    }
  }

  .reset-password-header {
    background-color: #33ADEE;
    text-align: center;
    padding: 2.2em 0 1.6em;
    position: relative;

    .close {
      background: none;
      border: none;
      box-shadow: none;
      position: absolute;
      right: 5px;
      top: 0;
      line-height: 1;
      padding: 3px;
      font-size: 21px;
      font-weight: 700;
      color: #000;
      text-shadow: 0 1px 0 #fff;
      opacity: .2;
      cursor: pointer;
      transition: opacity .3s ease;

      &:hover {
        opacity: 1;
      }
    }

    .header-logo {
      height: 80px;
      background: url('../assets/images/liberal-logo-white-type.svg') no-repeat center;
    }

    .header-title {
      margin-top: .8em;
      color: #fff;
      font-size: 1.6rem;
      font-weight: 400;
    }
  }

  .reset-password-auth-body {
    padding: 27px 25px;
  }

  .reset-password-container {
    /*padding: 25px 40px;
  border: solid 1px #A5A5A5;
  border-radius: 4px;*/

    .reset-password-box {
      /*padding: 25px;*/

      h2 {
        color: #15549A;
        margin: 0;
      }

      p {
        font-size: 0.825rem;
        line-height: 20px;
        margin-top: 30px;
        margin-bottom: 0;
      }

      .el-divider {
        margin-top: 17px;
      }

      .el-alert {
        margin-bottom: 15px;
      }

      .el-form {
        .text-muted {
          display: inline-block;
          color: #606266;
          font-size: 0.825rem;
          font-style: italic;
          margin-bottom: 10px;
        }

        .el-form-item {
          margin-bottom: 10px !important;

          &.request-token {
            margin-bottom: 0 !important;
          }

          > > > .el-form-item__label {
            line-height: 22px;
            font-weight: bold;
          }

          > > > .el-form-item__content {
            .el-form-item__error {
              padding-top: 0;
              padding-bottom: 4px;
            }
          }
        }
      }

      .form-action {
        margin-top: 30px;

        .btn-submit {
          font-weight: bold;
          font-size: 16px;
          width: 100%;
          padding-top: 18px;
          padding-bottom: 18px;
        }

        .el-button--text {
          margin-left: 0;
          color: #67C23A;
          padding-top: 6px;
          padding-bottom: 0;

          &:hover {
            font-weight: bold;
          }
        }
      }
    }
  }
</style>
